namespace AgerLMS.Logging {
    export interface SendSmsRequest extends Serenity.ServiceRequest {
        UserId?: number;
        Numbers?: string;
        Message?: string;
    }
}
